import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Clock, Trash2, Save } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const rellenar = (t, v) => t.replaceAll("{paciente}", v.paciente).replaceAll("{total}", v.total);
const plantillar = (t, v) => (v.paciente ? t.replaceAll(v.paciente, "{paciente}") : t).replaceAll(v.total, "{total}");

export const PlantillasEmail = ({ canal = "mail", asunto = "", cuerpo, vars, onApply }) => {
  const [lista, setLista] = useState([]);
  const [sel, setSel] = useState("");
  useEffect(() => {
    api.get("/plantillas-email", { params: { canal } }).then((r) => setLista(r.data));
  }, [canal]);
  const aplicar = (id) => {
    setSel(id);
    const t = lista.find((x) => x.id === id);
    if (t) onApply(rellenar(t.asunto, vars), rellenar(t.cuerpo, vars));
  };
  const guardar = async () => {
    const nombre = window.prompt("Nombre de la plantilla (p. ej. Bono semanal, Syntonic…)", lista.find((x) => x.id === sel)?.nombre || "");
    if (!nombre?.trim()) return;
    try {
      const { data } = await api.post("/plantillas-email", { nombre, canal, asunto: plantillar(asunto, vars), cuerpo: plantillar(cuerpo, vars) });
      setLista(data);
      setSel(data.find((x) => x.nombre === nombre.trim())?.id || "");
      toast.success("Plantilla guardada");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const borrar = async () => {
    if (!sel || !window.confirm("¿Borrar esta plantilla?")) return;
    const { data } = await api.delete(`/plantillas-email/${sel}`);
    setLista(data);
    setSel("");
    toast.success("Plantilla borrada");
  };
  return (
    <div className="flex gap-1 mt-1" data-testid={`ppto-plantillas-${canal}`}>
      <select className="field-select h-9 text-sm py-0 flex-1" value={sel} onChange={(e) => aplicar(e.target.value)} data-testid={canal === "wa" ? "ppto-plantilla-wa-select" : "ppto-plantilla-select"}>
        <option value="">{lista.length ? "Usar una plantilla guardada…" : "Sin plantillas guardadas"}</option>
        {lista.map((t) => <option key={t.id} value={t.id}>{t.nombre}</option>)}
      </select>
      <button type="button" onClick={guardar} title="Guardar este texto como plantilla" data-testid={canal === "wa" ? "ppto-plantilla-wa-guardar" : "ppto-plantilla-guardar"} className="inline-flex items-center gap-1 rounded-md border border-slate-300 px-2 text-xs text-slate-700"><Save className="h-3.5 w-3.5" />Guardar plantilla</button>
      {sel && <button type="button" onClick={borrar} title="Borrar plantilla" data-testid={canal === "wa" ? "ppto-plantilla-wa-borrar" : "ppto-plantilla-borrar"} className="rounded-md border border-slate-300 px-2 text-slate-500 hover:text-rose-600"><Trash2 className="h-3.5 w-3.5" /></button>}
    </div>
  );
};

const manana9 = () => {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  d.setHours(9, 0, 0, 0);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};

export const fmtFechaHora = (iso) => new Date(iso).toLocaleString("es-ES", { weekday: "long", day: "numeric", month: "long", hour: "2-digit", minute: "2-digit" });

export const ProgramarEnvio = ({ busy, onProgramar }) => {
  const [val, setVal] = useState(manana9());
  const programar = () => {
    const d = new Date(val);
    if (Number.isNaN(d.getTime()) || d <= new Date()) return toast.error("Elige un día y una hora futuros");
    onProgramar(d.toISOString());
  };
  return (
    <div className="flex flex-wrap items-center gap-2 mt-2" data-testid="ppto-programar">
      <span className="text-slate-600">Programar envío:</span>
      <input type="datetime-local" step={900} className="h-9 text-sm border border-slate-200 rounded px-2" value={val} onChange={(e) => setVal(e.target.value)} data-testid="ppto-programar-fecha" />
      <button type="button" onClick={programar} disabled={busy} data-testid="ppto-programar-btn" className="inline-flex items-center gap-1 rounded-md bg-[#1E3A8A] text-white px-3 h-9 text-sm disabled:opacity-60"><Clock className="h-4 w-4" />Programar</button>
    </div>
  );
};
